module.exports = __webpack_public_path__ + "img/logo_bottom2.158e0176.jpg";